import { BreadcrumbProps } from '@blueprintjs/core'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { Filters, PerformanceFilters, TableName } from '../../config'
import { useKdpFilters } from '../../hooks/useKdpFilters'
import { useUser } from '../../hooks/useUser'
import { CampaignPlacement } from '../../types/campaign'
import { TableProps } from '../ad_groups/AdGroupsTable'
import { Layout } from '../Layout'
import { Columns, defaultPerfColumns } from '../table2/ad_grid_columns'
import { AgGridColumnDef, AgGridTable } from '../table2/AgGridTable'
import { addExtraCols } from './CampaignsTable'

export const AdGroupType = {
    Keyword: 1,
    Target: 2,
    Auto: 3,
    Empty: 4,
}

const defaultFilters = [
    Filters.PortfolioId,
    Filters.PlacementId,
    Filters.State,
    Filters.TargetingType,
    Filters.StartDate,
    Filters.EndDate,
    ...PerformanceFilters,
]

const mutableFields: string[] = [
    'targetAcos',
    'dailyBudget',
    'state',
    'startDate',
    'endDate',
    'portfolio',
    'smart_bid',
]

export const CampaignPlacementsTable = observer(
    ({
        nested,
        store,
        savedFiltersStore,
        tableHooks,
    }: TableProps<CampaignPlacement>): JSX.Element => {
        const useUserValues = useUser()
        const filters = useKdpFilters(defaultFilters)

        const breadcrumbs: BreadcrumbProps[] = [{ text: 'Manage' }]

        const cols3 = useMemo(() => {
            return newColumns(useUserValues.is_kdp)
        }, [useUserValues.is_kdp])

        return (
            <Layout
                breadcrumbs={breadcrumbs}
                primary={TableName.CampaignPlacement}
                nested={nested}
                params={tableHooks.params}
            >
                <AgGridTable
                    name={TableName.CampaignPlacement}
                    columns={cols3}
                    tableHooks={tableHooks}
                    store={store}
                    showHeader={false}
                    savedFiltersStore={savedFiltersStore}
                    filters={filters}
                    search
                    searchPlaceholder="Search by campaign name"
                    mutableFields={mutableFields}
                    nested={nested}
                />
            </Layout>
        )
    },
)

const newColumns = <T,>(isKdp: boolean): AgGridColumnDef<T>[] => {
    const cols: AgGridColumnDef<T>[] = [
        Columns.CampaignName,
        Columns.Placement,
        Columns.BidAdjustment,
        Columns.StartDate,
        Columns.EndDate,
        Columns.ProductAdsCount,
        ...defaultPerfColumns,
    ]

    addExtraCols(cols, isKdp)

    return cols
}
